import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ScholarshipProviderType } from "../../../types/ScholarshipProviderType";

const initialState: ScholarshipProviderType = {
    description: "",
    code: "",
    internalCode: "",
    status: true,
    id: "",
};

export const scholarshipProviderSlice = createSlice({
    name: "scholarshipProviderForm",
    initialState,
    reducers: {
        setScholarshipProviderData: (state, action: PayloadAction<ScholarshipProviderType>) => {
            return { ...state, ...action.payload };
        },
        resetScholarshipProviderData: () => {
            return initialState;
        }
    }
});

export const { setScholarshipProviderData, resetScholarshipProviderData } = scholarshipProviderSlice.actions;
export default scholarshipProviderSlice.reducer;
